// Navigating into a risk assessment is a full page load, so where the user was is
// stashed on the way out and restored on the way back.
export const returnStateKey = 'riskRegister|returnState';

export const riskAssessmentRowElementId = (masterActivityTradeId) =>
  `riskAssessmentRow-${masterActivityTradeId}`;

export const categoryRowElementId = (tradeId) => `category-${tradeId}`;
